"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookingAwayError = exports.InvalidSimplifyError = exports.InvalidCodeError = exports.NotSupportMeasuringArea = exports.NotSupportMeasuringDistance = exports.NotConvergeCalculationError = exports.NotAllowedCwLinearRingError = exports.FalidCuttingAntimeridianError = exports.InvalidSelfintersectionError = exports.NotAllowedWarpBoundsError = exports.InvalidBoundsError = exports.InvalidLinearRingEnclosingPoleError = exports.EnclosingBothPolesError = exports.InvalidLinearRingError = exports.InvalidPointsError = exports.InvalidPointError = exports.InvalidNumberError = void 0;
var CustomError = /** @class */ (function (_super) {
    __extends(CustomError, _super);
    function CustomError(m) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, m) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return CustomError;
}(Error));
var InvalidNumberError = /** @class */ (function (_super) {
    __extends(InvalidNumberError, _super);
    function InvalidNumberError(m) {
        if (m === void 0) { m = "not number."; }
        return _super.call(this, m) || this;
    }
    return InvalidNumberError;
}(CustomError));
exports.InvalidNumberError = InvalidNumberError;
var InvalidPointError = /** @class */ (function (_super) {
    __extends(InvalidPointError, _super);
    function InvalidPointError(m) {
        if (m === void 0) { m = "point must be number array and have length 2 or more."; }
        return _super.call(this, m) || this;
    }
    return InvalidPointError;
}(CustomError));
exports.InvalidPointError = InvalidPointError;
var InvalidPointsError = /** @class */ (function (_super) {
    __extends(InvalidPointsError, _super);
    function InvalidPointsError(m) {
        if (m === void 0) { m = "points must be point array."; }
        return _super.call(this, m) || this;
    }
    return InvalidPointsError;
}(CustomError));
exports.InvalidPointsError = InvalidPointsError;
var InvalidLinearRingError = /** @class */ (function (_super) {
    __extends(InvalidLinearRingError, _super);
    function InvalidLinearRingError(m) {
        if (m === void 0) { m = "invalid linear ring."; }
        return _super.call(this, m) || this;
    }
    return InvalidLinearRingError;
}(CustomError));
exports.InvalidLinearRingError = InvalidLinearRingError;
var EnclosingBothPolesError = /** @class */ (function (_super) {
    __extends(EnclosingBothPolesError, _super);
    function EnclosingBothPolesError(m) {
        if (m === void 0) { m = "not support linear ring enclosing north and south poles."; }
        return _super.call(this, m) || this;
    }
    return EnclosingBothPolesError;
}(CustomError));
exports.EnclosingBothPolesError = EnclosingBothPolesError;
var InvalidLinearRingEnclosingPoleError = /** @class */ (function (_super) {
    __extends(InvalidLinearRingEnclosingPoleError, _super);
    function InvalidLinearRingEnclosingPoleError(m) {
        if (m === void 0) { m = "invalid linear ring enclosing the pole."; }
        return _super.call(this, m) || this;
    }
    return InvalidLinearRingEnclosingPoleError;
}(CustomError));
exports.InvalidLinearRingEnclosingPoleError = InvalidLinearRingEnclosingPoleError;
var InvalidBoundsError = /** @class */ (function (_super) {
    __extends(InvalidBoundsError, _super);
    function InvalidBoundsError(m) {
        if (m === void 0) { m = "invalid bounds."; }
        return _super.call(this, m) || this;
    }
    return InvalidBoundsError;
}(CustomError));
exports.InvalidBoundsError = InvalidBoundsError;
var NotAllowedWarpBoundsError = /** @class */ (function (_super) {
    __extends(NotAllowedWarpBoundsError, _super);
    function NotAllowedWarpBoundsError(m) {
        if (m === void 0) { m = "not support warpping bounds."; }
        return _super.call(this, m) || this;
    }
    return NotAllowedWarpBoundsError;
}(CustomError));
exports.NotAllowedWarpBoundsError = NotAllowedWarpBoundsError;
var InvalidSelfintersectionError = /** @class */ (function (_super) {
    __extends(InvalidSelfintersectionError, _super);
    function InvalidSelfintersectionError(m) {
        if (m === void 0) { m = "invalid selfintersection."; }
        return _super.call(this, m) || this;
    }
    return InvalidSelfintersectionError;
}(CustomError));
exports.InvalidSelfintersectionError = InvalidSelfintersectionError;
var FalidCuttingAntimeridianError = /** @class */ (function (_super) {
    __extends(FalidCuttingAntimeridianError, _super);
    function FalidCuttingAntimeridianError(m) {
        if (m === void 0) { m = "falid cutting antimeridian."; }
        return _super.call(this, m) || this;
    }
    return FalidCuttingAntimeridianError;
}(CustomError));
exports.FalidCuttingAntimeridianError = FalidCuttingAntimeridianError;
var NotAllowedCwLinearRingError = /** @class */ (function (_super) {
    __extends(NotAllowedCwLinearRingError, _super);
    function NotAllowedCwLinearRingError(m) {
        if (m === void 0) { m = "not support cw linear ring."; }
        return _super.call(this, m) || this;
    }
    return NotAllowedCwLinearRingError;
}(CustomError));
exports.NotAllowedCwLinearRingError = NotAllowedCwLinearRingError;
var NotConvergeCalculationError = /** @class */ (function (_super) {
    __extends(NotConvergeCalculationError, _super);
    function NotConvergeCalculationError(m) {
        if (m === void 0) { m = "not converge calculation."; }
        return _super.call(this, m) || this;
    }
    return NotConvergeCalculationError;
}(CustomError));
exports.NotConvergeCalculationError = NotConvergeCalculationError;
var NotSupportMeasuringDistance = /** @class */ (function (_super) {
    __extends(NotSupportMeasuringDistance, _super);
    function NotSupportMeasuringDistance(m) {
        if (m === void 0) { m = "not support measuring distance."; }
        return _super.call(this, m) || this;
    }
    return NotSupportMeasuringDistance;
}(CustomError));
exports.NotSupportMeasuringDistance = NotSupportMeasuringDistance;
var NotSupportMeasuringArea = /** @class */ (function (_super) {
    __extends(NotSupportMeasuringArea, _super);
    function NotSupportMeasuringArea(m) {
        if (m === void 0) { m = "not support measuring area."; }
        return _super.call(this, m) || this;
    }
    return NotSupportMeasuringArea;
}(CustomError));
exports.NotSupportMeasuringArea = NotSupportMeasuringArea;
var InvalidCodeError = /** @class */ (function (_super) {
    __extends(InvalidCodeError, _super);
    function InvalidCodeError(m) {
        if (m === void 0) { m = "unsupported epsg code."; }
        return _super.call(this, m) || this;
    }
    return InvalidCodeError;
}(CustomError));
exports.InvalidCodeError = InvalidCodeError;
var InvalidSimplifyError = /** @class */ (function (_super) {
    __extends(InvalidSimplifyError, _super);
    function InvalidSimplifyError(m) {
        if (m === void 0) { m = "arguments of simplify is invalid."; }
        return _super.call(this, m) || this;
    }
    return InvalidSimplifyError;
}(CustomError));
exports.InvalidSimplifyError = InvalidSimplifyError;
var LookingAwayError = /** @class */ (function (_super) {
    __extends(LookingAwayError, _super);
    function LookingAwayError(m) {
        if (m === void 0) { m = "not found ground point."; }
        return _super.call(this, m) || this;
    }
    return LookingAwayError;
}(CustomError));
exports.LookingAwayError = LookingAwayError;
